import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

const RADIUS = `var(${borderRadius.md.desktop})`;
/* How far the card stacked behind the image shows above it and in from its sides. */
const STACK_OFFSET = '4px';

export const card = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.xs});
  width: 175px;
  text-decoration: none;
  color: var(${colors.content.default});

  &:focus-visible {
    outline: 2px solid var(${colors.stroke.focus});
    outline-offset: var(${spacing.xxs});
    border-radius: ${RADIUS};
  }
`;

/* The design draws a second card peeking out from behind the image, so the
   department reads as a collection rather than a single product. */
export const media = css`
  position: relative;
  display: block;
  aspect-ratio: 3 / 2;
  border-radius: ${RADIUS};
  background-color: var(${colors.surface.disabled});

  &::before {
    content: '';
    position: absolute;
    inset: -${STACK_OFFSET} ${STACK_OFFSET} calc(${STACK_OFFSET} * 2);
    z-index: -1;
    border-radius: ${RADIUS};
    background-color: var(${colors.surface.disabled});
  }
`;

export const image = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${RADIUS};
`;

export const title = css`
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  font-weight: 700;
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  overflow-wrap: anywhere;
`;
